import type { CSSProperties } from 'react';
import type { LiveMask } from '@/types';

// Every sponsor mark on the live screens is a CSS mask over a solid colour, which is how
// it picks up the edition's yellow. The prefixed properties are kept because the OBS
// browser source is Chromium and the Next components set both.
export function logoMaskStyle(src: string): CSSProperties {
  return {
    WebkitMaskImage: `url(${src})`,
    WebkitMaskPosition: 'center',
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskSize: 'contain',
    maskImage: `url(${src})`,
    maskPosition: 'center',
    maskRepeat: 'no-repeat',
    maskSize: 'contain',
  };
}

// The same mask sized by aspect ratio rather than by pixels — the stage header's and the
// splash screens' "ft." mark, and the sponsor group at the bottom of a splash.
export function maskStyle(mask: LiveMask, extra?: CSSProperties): CSSProperties {
  return {
    aspectRatio: mask.aspectRatio,
    backgroundColor: 'hsl(var(--primary))',
    ...logoMaskStyle(mask.src),
    ...extra,
  };
}
